import type { ReactElement } from "react";
import { Container, Paper, Stack, Typography } from "@mui/material";

export default function TermsPage(): ReactElement {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 } }}>
      <Paper component="article" aria-labelledby="terms-title">
        <Stack spacing={2} sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography id="terms-title" component="h1" variant="h4">
            Terms Of Service
          </Typography>
          <Typography>Your site's terms go here.</Typography>
        </Stack>
      </Paper>
    </Container>
  );
}
